// extracted by mini-css-extract-plugin
export default {"content":"Content-module__content-v7uM","center":"Content-module__center-WhtI"};